import { httpClientBot } from "@/libraries";

export default {
  async createInteraction(payload) {
    return await httpClientBot.post("/interactions", payload);
  },
};
